import { useState } from 'react';
import { CandidatePrivateDataCard } from './components/CandidatePrivateDataCard';
import { CandidatePrivateDataForm } from './components/CandidatePrivateDataForm';
import type { CandidatePrivateDetails } from './types';
import { getAgeFromBirthAt } from './utils/getAgeFromBirthAt';
import { getCandidatePrivateDataEditInitialValues } from './utils/getCandidatePrivateDataEditInitialValues';

export type CandidatePrivateDataProps = {
  data: CandidatePrivateDetails;
};

export const CandidatePrivateData = ({ data }: CandidatePrivateDataProps) => {
  const [isEdit, setIsEdit] = useState(false);
  const age = getAgeFromBirthAt(data.birthAt);

  if (isEdit) {
    return (
      <CandidatePrivateDataForm
        age={age}
        initialValues={getCandidatePrivateDataEditInitialValues(data)}
        interviewRequired={data.interviewRequired}
        onCancel={() => setIsEdit(false)}
      />
    );
  }

  return (
    <CandidatePrivateDataCard
      lastName={data.lastName ?? undefined}
      age={age?.toString()}
      firstName={data.firstName ?? undefined}
      generalInfo={data.generalInfo}
      phone={data.phone}
      preferredCommunicationLanguage={
        data.preferredCommunicationLanguage ?? undefined
      }
      allCities={data.allCities}
      cityIds={data.cityIds}
      educationLevel={data.educationLevel?.name}
      professionName={data.educationLevel?.professionName}
      onEdit={() => setIsEdit(true)}
    />
  );
};
